export type TextCounts = {
  characters: number;
  words: number;
  sentences: number;
  paragraphs: number;
  lines: number;
};

export function countCharacters(text: string, countSpaces: boolean): number {
  if (!text) return 0;
  if (countSpaces) return text.length;
  return text.replace(/ /g, "").length;
}

export function countWords(text: string): number {
  const trimmed = text.trim();
  if (!trimmed) return 0;
  return trimmed.split(/\s+/).length;
}

export function countSentences(text: string): number {
  const trimmed = text.trim();
  if (!trimmed) return 0;

  const matches = trimmed.match(/[^.!?]+[.!?]+|[^.!?]+$/g);
  if (!matches) return 0;

  return matches.filter((part) => part.trim().length > 0).length;
}

export function countParagraphs(text: string): number {
  const trimmed = text.trim();
  if (!trimmed) return 0;

  return trimmed
    .split(/\n\s*\n/)
    .map((block) => block.trim())
    .filter(Boolean).length;
}

export function countLines(text: string): number {
  if (!text) return 0;
  return text.split("\n").length;
}

export function countText(text: string, countSpaces: boolean): TextCounts {
  return {
    characters: countCharacters(text, countSpaces),
    words: countWords(text),
    sentences: countSentences(text),
    paragraphs: countParagraphs(text),
    lines: countLines(text),
  };
}
